var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64024 0H12.9889L20.9122 8.25869V24.3219C20.9122 26.3342 19.2842 27.9621 17.2789 27.9621H3.64024C1.62798 27.9621 5.75036e-10 26.3342 5.75036e-10 24.3219V3.64024C-3.53295e-05 1.62798 1.62794 0 3.64024 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9824 3.05176e-05V8.19584H20.9127L12.9824 3.05176e-05Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0459 20.8633V15.7558H6.21888C6.75688 15.7558 7.1831 15.9025 7.5045 16.203C7.8259 16.4964 7.98662 16.8947 7.98662 17.3908C7.98662 17.8868 7.8259 18.2851 7.5045 18.5786C7.1831 18.879 6.75688 19.0257 6.21888 19.0257H5.35248V20.8633H4.0459ZM5.35248 17.9148H6.07215C6.26777 17.9148 6.42149 17.8729 6.52632 17.7751C6.63111 17.6843 6.68703 17.5585 6.68703 17.3908C6.68703 17.2231 6.63114 17.0974 6.52632 17.0065C6.42153 16.9087 6.26781 16.8668 6.07215 16.8668H5.35248V17.9148ZM8.52459 20.8633V15.7558H10.3342C10.6906 15.7558 11.026 15.8047 11.3404 15.9095C11.6548 16.0143 11.9413 16.1611 12.1928 16.3637C12.4443 16.5593 12.6469 16.8248 12.7937 17.1602C12.9334 17.4956 13.0103 17.8799 13.0103 18.3131C13.0103 18.7393 12.9334 19.1236 12.7937 19.4589C12.6469 19.7943 12.4443 20.0598 12.1928 20.2554C11.9412 20.4581 11.6548 20.6048 11.3404 20.7096C11.026 20.8144 10.6906 20.8633 10.3342 20.8633H8.52459ZM9.80322 19.7524H10.1805C10.3831 19.7524 10.5718 19.7315 10.7465 19.6825C10.9141 19.6336 11.0749 19.5568 11.2286 19.452C11.3753 19.3472 11.4941 19.2004 11.5779 19.0048C11.6618 18.8092 11.7037 18.5786 11.7037 18.3131C11.7037 18.0406 11.6618 17.81 11.5779 17.6144C11.4941 17.4188 11.3753 17.272 11.2286 17.1672C11.0749 17.0624 10.9142 16.9855 10.7465 16.9366C10.5718 16.8877 10.3831 16.8668 10.1805 16.8668H9.80322V19.7524ZM13.6671 20.8633V15.7558H17.3003V16.8668H14.9736V17.6842H16.8322V18.7882H14.9736V20.8633H13.6671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPdf);
export default __webpack_public_path__ + "static/media/icn-pdf.cdb2158ea0a4c629ceb027ebea25559f.svg";
export { ForwardRef as ReactComponent };